export enum DataType {
  UNKNOWN_DataType = 'UNKNOWN_DataType',
  /** A simple text value */
  text = 'text',
  /** A list of predefined textual values to choose from */
  textEnum = 'textEnum',
  /** Any number */
  number = 'number',
  /** true / false value */
  booleanValue = 'booleanValue',
  /** An object containing the selected A11Y fields chosen */
  a11y = 'a11y',
  /** A Wix Link object type */
  link = 'link',
  /** A Wix Image object type */
  image = 'image',
  /** A Wix Video object type */
  video = 'video',
  /** A Wix Sanitized Vector Art object */
  vectorArt = 'vectorArt',
  /** A Wix Audio object */
  audio = 'audio',
  /** A [JSON Schema definition](https://json-schema.org/specification) the developer understands in his code (useful for complex props). Some limitation may apply. */
  schema = 'schema',
  /** Local date output ISO-8601 extended local date format (YYYY-MM-DD) */
  localDate = 'localDate',
  /** Local time output ISO-8601 extended local time format (hh:mm[:ss][.sss]) */
  localTime = 'localTime',
  /** Local Date Time output  ISO-8601 extended local date-time format (YYYY-MM-DDThh:mm[:ss][.sss]) */
  localDateTime = 'localDateTime',
  /** a URL with scheme http or https */
  webUrl = 'webUrl',
  /** standard email address according to [RFC 5321, section 4.1.2](https://datatracker.ietf.org/doc/html/rfc5321#section-4.1.2) */
  email = 'email',
  /** a validation format designed to match phone numbers with a variety of common characters, including digits (0-9), spaces, parentheses, plus sign, hyphens, and periods */
  phone = 'phone',
  /** hostname according to IANA */
  hostname = 'hostname',
  /** A valid `regex` pattern supplied by the User */
  regex = 'regex',
  /** A unique identifier */
  guid = 'guid',
  /** a HTML text with css inline styling */
  richText = 'richText',
  /** A container place in the component that will be passed in as {children} or a function prop, depending on the case */
  container = 'container',
  /** An array type of data */
  arrayItems = 'arrayItems',
  /** selected `direction` for the component according to (HTML `dir` attribute)[https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir] */
  direction = 'direction',
}

export enum StyleType {
  UNKNOWN_CssPropertyType = 'UNKNOWN_CssPropertyType',
  booleanValue = 'booleanValue',
  stringEnum = 'stringEnum', // leaving until vertical fully migrate
  numberEnum = 'numberEnum', // leaving until vertical fully migrate
  legacyFontStyleParamEnum = 'legacyFontStyleParamEnum', // fake font workaround
  customEnum = 'customEnum',
  number = 'number',

  /** background properties */
  background = 'background',
  backgroundSize = 'backgroundSize',
  backgroundColor = 'backgroundColor',
  backgroundImage = 'backgroundImage',
  backgroundClip = 'backgroundClip',
  backgroundOrigin = 'backgroundOrigin',
  backgroundPosition = 'backgroundPosition',
  backgroundRepeat = 'backgroundRepeat',
  backgroundAttachment = 'backgroundAttachment',
  /** margin properties */
  margin = 'margin',
  marginTop = 'marginTop',
  marginRight = 'marginRight',
  marginBottom = 'marginBottom',
  marginLeft = 'marginLeft',
  marginInlineStart = 'marginInlineStart',
  marginInlineEnd = 'marginInlineEnd',
  /** padding properties */
  padding = 'padding',
  paddingTop = 'paddingTop',
  paddingRight = 'paddingRight',
  paddingBottom = 'paddingBottom',
  paddingLeft = 'paddingLeft',
  paddingInlineStart = 'paddingInlineStart',
  paddingInlineEnd = 'paddingInlineEnd',
  /** border properties */
  border = 'border',
  borderWidth = 'borderWidth',
  borderStyle = 'borderStyle',
  borderColor = 'borderColor',
  borderTop = 'borderTop',
  borderTopColor = 'borderTopColor',
  borderTopWidth = 'borderTopWidth',
  borderTopStyle = 'borderTopStyle',
  borderRight = 'borderRight',
  borderRightColor = 'borderRightColor',
  borderRightWidth = 'borderRightWidth',
  borderRightStyle = 'borderRightStyle',
  borderBottom = 'borderBottom',
  borderBottomColor = 'borderBottomColor',
  borderBottomWidth = 'borderBottomWidth',
  borderBottomStyle = 'borderBottomStyle',
  borderLeft = 'borderLeft',
  borderLeftColor = 'borderLeftColor',
  borderLeftWidth = 'borderLeftWidth',
  borderLeftStyle = 'borderLeftStyle',
  borderInlineStart = 'borderInlineStart',
  borderInlineStartColor = 'borderInlineStartColor',
  borderInlineStartWidth = 'borderInlineStartWidth',
  borderInlineStartStyle = 'borderInlineStartStyle',
  borderInlineEnd = 'borderInlineEnd',
  borderInlineEndColor = 'borderInlineEndColor',
  borderInlineEndWidth = 'borderInlineEndWidth',
  borderInlineEndStyle = 'borderInlineEndStyle',
  borderRadius = 'borderRadius',
  borderTopLeftRadius = 'borderTopLeftRadius',
  borderTopRightRadius = 'borderTopRightRadius',
  borderBottomRightRadius = 'borderBottomRightRadius',
  borderBottomLeftRadius = 'borderBottomLeftRadius',
  borderStartStartRadius = 'borderStartStartRadius',
  borderStartEndRadius = 'borderStartEndRadius',
  borderEndStartRadius = 'borderEndStartRadius',
  borderEndEndRadius = 'borderEndEndRadius',
  /** text properties */
  font = 'font',
  fontFamily = 'fontFamily',
  fontSize = 'fontSize',
  fontStretch = 'fontStretch',
  fontStyle = 'fontStyle',
  fontVariant = 'fontVariant',
  fontWeight = 'fontWeight',
  lineHeight = 'lineHeight',
  color = 'color',
  letterSpacing = 'letterSpacing',
  textAlign = 'textAlign',
  textTransform = 'textTransform',
  textShadow = 'textShadow',
  textDecoration = 'textDecoration',
  textDecorationColor = 'textDecorationColor',
  textDecorationLine = 'textDecorationLine',
  textDecorationStyle = 'textDecorationStyle',
  textDecorationThickness = 'textDecorationThickness',
  /** general box properties */
  boxShadow = 'boxShadow',
  opacity = 'opacity',
  overflow = 'overflow',
  /** layout properties */
  alignSelf = 'alignSelf',
  justifyContent = 'justifyContent',
  alignItems = 'alignItems',
  flexDirection = 'flexDirection',
  gap = 'gap',
  height = 'height',
  width = 'width',
  /** filters */
  filter = 'filter',
  backdropFilter = 'backdropFilter',
  /** media sizing & alignment */
  objectFit = 'objectFit',
  objectPosition = 'objectPosition',
  /** blending & compositing */
  mixBlendMode = 'mixBlendMode',
  isolation = 'isolation',
}
